import React from 'react';
import {sleep} from '../model/common';

class About extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            cssClass: 'message hide'
        };
    }

    handleClick() {
        this.setState({cssClass: 'message hide'});
        sleep(1200).then(() => this.props.changeView('start'));
    }

    componentDidMount() {
        sleep(500).then(() => this.setState({cssClass: 'message show'}));
    }

    render() {
        const snake = (<span style={{color: '#7D9E3C', fontWeight: 'bold'}}>snake</span>),
              pool = (<span style={{color: '#6ABCEB', fontWeight: 'bold'}}>pool</span>);

        return (
            <div className={this.state.cssClass} onClick={this.handleClick}>
                <h1 className={'title'}>Casual Snake<span>and the mystical pool</span></h1>
                <h3>
                    Casual Snake and the mystical pool?
                </h3>
                This game is a simple and fun take on a {snake} game with a twist. It introduces the concept of a {pool} that can make things quite interesting.

                <h3>
                    How do I control the {snake}?
                </h3>
                Use your arrow keys or swipe if you're using a mobile device.

                <h3>
                    I love this game, but it sucks to enter the URL in my mobile phone each time I want to play.
                </h3>
                Then add it as a desktop entry! :)

                <h3>
                    Is there a leaderboard?
                </h3>
                Nope, your scores are stored locally in your browser. Screenshots and other ways to brag about your points will have to do.

                <h3>
                    Things does not work. :/
                </h3>
                That may be because you're using Internet Explorer. This game was developed using Chrome, so you can always try to switch to that browser instead.

                <h3>
                    Who's responsible for this game?
                </h3>
                This {snake} game was created by Martin Moberg in a brave attempt
                to learn JavaScript. The code is available on <a target="blank" href="https://github.com/indifferen7/casual-snakejs">GitHub</a>.

                <p>
                    (tap/click for menu)
                </p>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/about.jsx